import { useState } from 'react';
import IExameLogo from './Logo.jsx';
import { Icon } from './Icons.jsx';

export default function LoginScreen({ onLogin, onBack, onSignup }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await onLogin(email, password);
    } catch (err) {
      setError(err.message || 'E-mail ou senha incorretos.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen" style={{ background: 'var(--bg)' }}>
      {/* hero */}
      <div className="hero-brand" style={{ background: 'linear-gradient(160deg, var(--midnight) 0%, var(--midnight-90) 55%, var(--navy-3) 100%)', color: 'var(--white)', padding: '58px 22px 34px', position: 'relative', overflow: 'hidden' }}>
        <svg width="280" height="280" style={{ position: 'absolute', right: -80, top: -60, opacity: 0.15 }}>
          {[...Array(6)].map((_, i) => <circle key={i} cx="140" cy="140" r={26 + i*20} stroke="var(--brand-primary)" strokeWidth="1" fill="none"/>)}
        </svg>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            {onBack ? (
              <button onClick={onBack} aria-label="Voltar" style={{
                width: 38, height: 38, borderRadius: 99,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: 'var(--overlay-white-12)', border: '1px solid var(--overlay-white-20)',
              }}>
                <Icon.chevL size={20} color="var(--white)"/>
              </button>
            ) : <IExameLogo size={30} color="var(--white)" accent="var(--brand-primary)"/>}
            <div style={{ padding: '5px 10px', borderRadius: 99, background: 'var(--overlay-primary-20)', color: 'var(--primary-tint-text)', fontSize: 10, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', fontFamily: 'var(--font-display)', whiteSpace: 'nowrap' }}>
              Exames clínicos · preço justo
            </div>
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.15, marginTop: 22, color: 'var(--white)' }}>
            Seus exames,<br/><span style={{ color: 'var(--brand-primary)' }}>sem pagar a mais.</span>
          </h1>
        </div>
      </div>

      {/* form */}
      <div style={{ flex: 1, padding: '26px 22px', display: 'flex', flexDirection: 'column' }}>
        <h2 style={{ fontSize: 22, fontWeight: 700 }}>Entrar</h2>
        <p style={{ color: 'var(--text-muted)', marginTop: 4, marginBottom: 22, fontSize: 14 }}>Acesse para agendar exames.</p>

        {error && (
          <div style={{ padding: '10px 14px', borderRadius: 10, background: 'var(--danger-tint)', color: 'var(--danger-strong)', fontSize: 13, marginBottom: 14, display: 'flex', gap: 8, alignItems: 'center' }}>
            <Icon.info size={16} color="var(--danger-strong)"/>{error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label className="input-label">E-mail ou CPF</label>
            <div style={{ position: 'relative' }}>
              <Icon.user size={18} color="var(--text-subtle)" style={{ position: 'absolute', left: 14, top: 16 }}/>
              <input className="input" type="text" value={email} onChange={e => setEmail(e.target.value)} style={{ paddingLeft: 42 }} placeholder="seu@email.com" required/>
            </div>
          </div>
          <div>
            <label className="input-label">Senha</label>
            <div style={{ position: 'relative' }}>
              <Icon.lock size={18} color="var(--text-subtle)" style={{ position: 'absolute', left: 14, top: 16 }}/>
              <input className="input" type={showPwd ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} style={{ paddingLeft: 42, paddingRight: 48 }} placeholder="••••••••" required/>
              <button type="button" onClick={() => setShowPwd(!showPwd)} style={{ position: 'absolute', right: 10, top: 13, padding: 6, color: 'var(--text-muted)' }}>
                {showPwd ? <Icon.eyeOff size={20}/> : <Icon.eye size={20}/>}
              </button>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: -4 }}>
            {/* Fluxo de e-mail (solicitar link + definir nova senha) já existe pronto
                em /iam/forgot-password e /iam/reset-password (páginas do próprio pacote
                iam, com verificação de identidade e regras de senha) — navegação de
                página cheia, não uma tela da SPA. */}
            <a href="/iam/forgot-password" style={{ fontSize: 13, color: 'var(--brand-primary)', fontWeight: 600, textDecoration: 'none' }}>Esqueci a senha</a>
          </div>
          <button type="submit" className="btn btn-primary" style={{ marginTop: 6 }} disabled={loading}>
            {loading ? 'Entrando…' : <> Entrar <Icon.arrowR size={18} color="var(--white)"/></>}
          </button>
        </form>

        <div style={{ flex: 1, background: 'var(--bg)' }}/>
        <div style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-muted)', marginTop: 24, paddingBottom: 12 }}>
          Ainda não tem conta?{' '}
          <a href="#" onClick={(e) => { e.preventDefault(); onSignup?.(); }} style={{ color: 'var(--brand-primary)', fontWeight: 600, textDecoration: 'none' }}>Cadastre-se</a>
        </div>
      </div>
    </div>
  );
}
